'use client'

import { serviceIdFromHost } from '@/lib/routing/service-host'
import { useEffect, useState } from 'react'
import { getNotFoundHeader } from './notFoundHeaderData'

// ルートの not-found は静的ページの RSC ペイロードにも描画される。
// headers() を使うと記事と /top が動的レンダリングに落ちるため、
// ホストはクライアントで解決する。
export const NotFoundHeader = () => {
  const [header, setHeader] = useState<{ html: string; name: string } | null>(
    null,
  )

  useEffect(() => {
    const serviceId = serviceIdFromHost(window.location.host)
    if (!serviceId) return
    void getNotFoundHeader(serviceId).then((value) => {
      if (value) setHeader(value)
    })
  }, [])

  if (!header) return null
  if (header.html) {
    return (
      <div
        className="header"
        dangerouslySetInnerHTML={{ __html: header.html }}
      />
    )
  }
  return (
    <div className="header">
      <a className="font-bold text-lg text-[#333]" href="/">
        {header.name}
      </a>
    </div>
  )
}
